import styled from "styled-components";
import {ProfileDescriptionInputProps} from "@betrue/ui";
import {StyledBaseProps} from "@betrue/shared/interfaces";
import {Button, Grid, TextField, Typography} from "@mui/material";
import * as React from "react";
import {Control, Controller} from "react-hook-form";

export interface ProfileDescriptionInputViewProps extends ProfileDescriptionInputProps, StyledBaseProps {
  isEditable: boolean
  onEdit: () => void
  description: string
  onSubmit: ((() => void))
  control: Control
}

export const PROFILE_DESCRIPTION = 'Graphiste depuis plus de 6 ans, geek et entrepreneur, je suis passionné par l’art et' +
  ' le design. Créative et joviale, j\'aime exprimer ma créativité dans mes travaux. j\'ai travaillé pour des grands groupes (Air France, Voyages SNCF, etc.). je saurai m’adapter à votre besoin, être réactive et vous rendre des visuels qualitatifs'
export const ProfileDescriptionInputView = styled((props: ProfileDescriptionInputViewProps) => (
  <div className={props.className}>
    <Grid container
          direction="column"
          spacing={3}
          justifyContent={'flex-start'}
    >
      <Grid item>
        <Typography component={'h2'} variant={'h4'}>
          {props.descriptionTitle}
        </Typography>
      </Grid>
      {props.isEditable ? (<Grid item>
        <Typography component={'p'}>
          {props.descriptionSubTitle}
        </Typography> </Grid>) : ''}

      {props.isEditable ? (<form onSubmit={props.onSubmit}><Grid item>

        <Controller
          name={"description"}
          defaultValue={!!props.description ? props.description : PROFILE_DESCRIPTION}
          render={({field, fieldState, formState}) => (
            <TextField
              {...field}
              helperText={fieldState.error?.message}
              error={!!(fieldState.invalid)}
              onSubmit={() => {
                if (field.value === PROFILE_DESCRIPTION) {
                  field.onChange('')
                }
              }}
              onSelect={() => {
                if (field.value === PROFILE_DESCRIPTION) {
                  field.onChange('')
                }
              }}
              label={props.textAreaLabel}
              fullWidth={true}
              multiline
              rows={6}

              variant="outlined"
            />)
          }
          control={props.control}/>
        <Grid item>
          <Button onClick={() => props.onEdit()} color="primary">
            {props.cancelButton}
          </Button>
          <Button type="submit" color="primary">
            {props.submitButton}
          </Button>
        </Grid>

      </Grid></form>) : (<Grid item>
        <Typography
          onClick={(e) => props.onEdit()}
          className={'bt-editable-area'}
          component={'p'}
        >
          {props.description ? props.description : PROFILE_DESCRIPTION}
        </Typography>
      </Grid>)}

    </Grid>
  </div>
))`
  & .bt-editable-area {
    cursor: pointer;
    padding: 10px;
  }

  & .bt-editable-area:hover {
    background-color: #eedbe5;
  }
`
